







































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import i18n from "@/i18n";
// types
import { ImageNews } from "@/services/news/types";

@Component
export default class ImageForm extends Vue {
    @Prop() content!: ImageNews[];
    @Prop() language!: string;

    // local state
    localProperties = {} as ImageNews;
    private tmpNewFile: File = {} as File;

    @Watch("content")
    onPropertyChanged() {
        if (this.content) {
            this.localProperties = this.content.find(x => x.language === this.language) || {} as ImageNews;
        }
    }

    // methods
    emitData() {
        this.localProperties.language = this.language;
        this.$emit("contentUpdated", this.localProperties, this.tmpNewFile);
    }

    openFileSelection(): void {
        (this.$refs.fileInput as any).click();
    }

    onFilesChanged(event: any) {
        if (!event.target.files[0]) return;
        this.tmpNewFile = event.target.files[0];
        this.localProperties.file = this.tmpNewFile.name;
    }
}
